import { render, staticRenderFns } from "./placard.vue?vue&type=template&id=361be33c&scoped=true"
import script from "./placard.vue?vue&type=script&lang=js"
export * from "./placard.vue?vue&type=script&lang=js"
import style0 from "./placard.vue?vue&type=style&index=0&id=361be33c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361be33c",
  null
  
)

export default component.exports